"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_TAG_SHOWN = exports.TagSortState = void 0;
const core_api_1 = require("@ikegps/core-api");
const icons_1 = require("../components/icon/icons");
const sortable_1 = require("../components/sortable/sortable");
const i18n_1 = require("../i18n");
const i18n_2 = require("../i18n");
const services_1 = require("../services");
const store_1 = require("../store");
const userDisplayName_1 = require("../util/userDisplayName");
function getCollectedBy(obj) {
    if (obj.collectedBy == null) {
        return null;
    }
    const user = store_1.AppStore.UserProfile.get(obj.collectedBy);
    if (user == null) {
        return null;
    }
    return user.username;
}
function getUpdatedAt(obj) {
    return obj.updatedAt || obj.createdAt;
}
function getDisplayUpdatedAt(obj) {
    return obj.updatedAt != null ? services_1.Services.DateTime.getDate(obj.updatedAt) : services_1.Services.DateTime.getDate(obj.createdAt);
}
function getAssignedTo(obj) {
    const userProfile = store_1.AppStore.UserProfile.get(obj.assignedTo);
    if (userProfile != null) {
        return (0, userDisplayName_1.userDisplayName)(userProfile);
    }
    return (0, i18n_1.Translate)(i18n_2.T.COLLECTION_UNASSIGNED);
}
const UNSORTED_KEY = '';
const SORT_OPTIONS = [
    {
        title: i18n_2.T.SORT_FIELD_UPDATED_AT,
        icon: icons_1.MaterialIcon.UPDATE,
        keys: {
            tag: getUpdatedAt,
            collection: getUpdatedAt,
        },
        value: {
            collection: getDisplayUpdatedAt,
        },
        info: {
            tag: true,
            collection: true,
        },
    },
    {
        title: i18n_2.T.SORT_FIELD_COLLECTED_AT,
        icon: icons_1.MaterialIcon.DATE,
        keys: {
            tag: 'createdAt',
            collection: (summary) => {
                return summary.collectedAt != null ? summary.collectedAt.iso : summary.createdAt;
            },
        },
        value: {
            collection: (summary) => {
                return summary.collectedAt != null
                    ? services_1.Services.DateTime.getDate(summary.collectedAt.iso)
                    : services_1.Services.DateTime.getDate(summary.createdAt);
            },
        },
        info: {
            tag: true,
            collection: true,
        },
    },
    {
        title: i18n_2.T.SORT_FIELD_NAME,
        icon: icons_1.MaterialIcon.SHORT_TEXT,
        keys: {
            tag: 'name',
            collection: 'title',
        },
        info: {},
    },
    {
        title: i18n_2.T.SORT_FIELD_COLLECTED_BY,
        icon: icons_1.MaterialIcon.PERSON,
        keys: {
            tag: UNSORTED_KEY,
            collection: getCollectedBy,
        },
        info: {
            collection: true,
        },
    },
    {
        title: i18n_2.T.SORT_FIELD_STATUS,
        icon: icons_1.MaterialIcon.STATUS,
        visible: () => services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_SORT_STATUS) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE),
        keys: {
            tag: UNSORTED_KEY,
            collection: 'status',
        },
        info: {
            collection: true,
        },
    },
    {
        title: i18n_2.T.SORT_FIELD_ASSIGNED,
        icon: icons_1.MaterialIcon.ASSIGN,
        visible: () => services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_ASSIGN) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE),
        keys: {
            tag: UNSORTED_KEY,
            collection: getAssignedTo,
        },
        info: {
            collection: true,
        },
    },
];
exports.TagSortState = new sortable_1.SortableState(SORT_OPTIONS);
exports.MAX_TAG_SHOWN = 50;
//# sourceMappingURL=tag.sort.state.js.map